import { GoogleOAuthProvider } from '@react-oauth/google';
import { ErrRes } from 'components';
import Auth from 'containers/Auth';
import { useSmartAppBanner } from 'hooks/useSmartAppBanner';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '../store';

/*
  THIS COMPONENT CONTAINS BASE OF THE APP.
  ROUTER AND STORE CONTAINERS ARE COVERING THE ROUTER OF THE APP
  OTHER TOP LEVEL COMPONENTS WHICH DOESN'T DEPEND ON ANY ROUTERS ARE ALSO CONTAINED HERE
*/
const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID
  ? process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID
  : '653995377488-pcpinlg8hm7dedf9lv59bkt9ssig2d65.apps.googleusercontent.com';

const RootContent = () => {
  useSmartAppBanner();

  return <Auth />;
};

const Root = () => {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ErrRes />

          <Router>
            <RootContent />
          </Router>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default Root;
